"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackProductListFiltered = exports.default = void 0;
var _trackingHelper = require("../trackingHelper");
var trackProductListFiltered = exports.trackProductListFiltered = function trackProductListFiltered(data) {
  var list_id = data.list_id,
    category = data.category,
    sorts = data.sorts,
    filters = data.filters;
  (0, _trackingHelper.trackEvent)('Product List Filtered', {
    list_id: list_id,
    category: category,
    sorts: sorts,
    filters: filters
  });
};
var _default = exports.default = trackProductListFiltered;